import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Header from '../Header';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { gaEvent, placeTypeName, placeTypeSort, plural } from '../../utils/utils';
import { SetQuery } from '../../actions';
import * as d3 from 'd3';
import styles from './SearchPage.css';
import withStyles from '../../decorators/withStyles';

function sortByName(a, b) {
  return a.name > b.name ? -1 : 1;
}

function sortByPopulation(a, b) {
  return a.population > b.population ? -1 : 1;
}


class SearchPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchVal: props.q,
      searchResults: {},
    };
  }

  static defaultProps = {
    limit: 5,
    scope: '',
  };

  componentDidMount() {
    if (this.props.q !== "") {
      this.loadData(this.props.q);
    }
  }

  componentWillReceiveProps(props) {
    if (props.q !== this.props.q) {
      this.setState({searchVal: props.q});
      if (props.q === "") {
        this.setState({searchResults: {}});
      } else {
        this.loadData(props.q);
      }
    }
  }

  async loadData(query) {
    const encodedQ = encodeURIComponent(query);
    const url = `/api/search?scope=${this.props.scope}&limit=${this.props.limit}&search=${encodedQ}`;
    const data = await d3.json(url);
    if (data) {
      this.setState({searchResults: data});
    }
  }

  submitSearch = () => {
    gaEvent('search', 'submit', 'search-page', this.state.searchVal);
    this.props.dispatch(SetQuery(this.state.searchVal.trim()));
    browserHistory.push({pathname: "/search", query: {q: this.state.searchVal.trim()}, state: {...this.props, q: this.state.searchVal}});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.submitSearch();
  };

  handleSearchChange = (e) => {
    this.setState({searchVal: e.target.value});
  };

  render() {
    var resultsList;
    var linkList;
    var places = this.state.searchResults.results || [];
    var placesByType = {};

    const placeElements = (placeName) => {
      const commas = placeName.match(/,/g);
      if (commas) {
        return placeName.split(',').map((elem, i) => <span>{elem}{i !== commas.length ? ',' : ''}</span>);
      } else {
        return <span>{placeName}</span>;
      }
    };

    if (typeof places === "undefined") {
      resultsList = <div></div>;
    } else if (places.length === 0) {
      resultsList = (
        <div>
          <h2>No places matching your search are currently available.</h2>
        </div>
      );
    } else {
      places.forEach(place => {
        if ("length" in place) {
          return;
        }
        if (place.placetype in placesByType) {
          if (place.geo_container.name in placesByType[place.placetype]) {
            placesByType[place.placetype][place.geo_container.name].push(place);
          } else {
            placesByType[place.placetype][place.geo_container.name] = [place];
          }
        } else {
          placesByType[place.placetype] = {};
          placesByType[place.placetype][place.geo_container.name] = [place];
        }
      });

      resultsList = (
        Object.keys(placesByType).sort((a, b) => placeTypeSort(a) > placeTypeSort(b) ? 1 : -1).map(placetype => {
          return (
            <div key={placetype}>
              <h2>
                <Link to={`/${placetype}`}>
                  {plural(placeTypeName(placetype))}
                </Link>
              </h2>

              <ul>
                {Object.keys(placesByType[placetype]).sort().reduce((a, containerName) => {
                  placesByType[placetype][containerName].forEach(place => {
                    a.push(
                      <li key={`/${place.placetype}/${place.id}`}>
                        <Link to={{pathname: `/${place.placetype}/${place.id}`,
                                   state: this.props}}>
                          {placeElements(place.name)}
                        </Link>
                      </li>
                    );
                    // FIXME: inefficient
                    a.sort(sortByName);
                  });
                  return a;
                }, [])}
              </ul>
            </div>
          )
        })
      );

      var relatedLinks = {};
      places.forEach(p => {
        if (!(p.geo_container.name in relatedLinks)) {
          relatedLinks[p.geo_container.name] = {
            links: p.related_links,
            containerID: p.geo_container.placeID
          };
        }
      });

      linkList = (
        Object.keys(relatedLinks).map(k => {
          return (
            relatedLinks[k].links.length > 0 ?
            <div key={k}>
              <h1>Places within {k}</h1>
              <ul>
                {relatedLinks[k].links.sort((a, b) => {
                  return placeTypeSort(a.placeType) > placeTypeSort(b.placeType) ? 1 : -1
                }).map(link =>
                  <li>
                    <Link to={{pathname: `/${link.placeType}`, query: {container: relatedLinks[k].containerID}}}>
                      {plural(link.placeTypeName)}
                    </Link>
                  </li>
                )}
              </ul>
            </div> : null
          );
        })
      );
    }

    return (
      <div>
        <Header mobileMenuOpen={this.props.mobileMenuOpen}
                modalVisible={this.props.modalVisible}
                searchable={this.props.routes[this.props.routes.length - 1].searchable} />
        <div className="SearchPage">
          <main>
            <section>
              <form className="search" target="#" onSubmit={this.handleSubmit}>
                <input
                  className="query type-regular homepage"
                  placeholder="Enter a U.S. coastal place"
                  type="search"
                  onChange={this.handleSearchChange}
                  value={this.state.searchVal}
                  autoFocus
                />
                <input className="submit" type="submit"/>
                <span className="icon-wrap" onClick={this.submitSearch}><span className="icon search"></span></span>
                <div className="search-error">
                  <a href="#" className="close">×</a>
                  <div className="error-text"></div>
                </div>
              </form>
            </section>
            <section>
              {places ?
                <div>
                  <h1>Places found matching <span>&ldquo;{this.props.q}&rdquo;</span></h1>
                  <hr/>
                  {resultsList}
                  <br/>
                  {linkList ?
                    <div>
                      <hr/>
                      {linkList}
                    </div> : null
                  }
                  <hr/>
                  <p>Don't see what you're looking for? We can provide custom analysis.
                For more, please check out <a href="http://sealevel.climatecentral.org/maps/custom-analysis" target="_blank">our offerings</a>.</p>
                </div> :
                <div>
                  <p className="center">Need something else? We can provide custom analysis.
                For more, please check out <a href="http://sealevel.climatecentral.org/maps/custom-analysis" target="_blank">our offerings</a>.</p>
                </div>
              }

            </section>
          </main>
        </div>
      </div>
    );

  };

}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(SearchPage);
